<template>
	<div class="product-tag">
		<search-product-tag
			v-on:addProductTag="addProductTag"
			v-on:onSubmit="onSubmit"
			v-on:resetSearch="resetSearch"
			:search="search"
		>
		</search-product-tag>
		<add-product-tag
			v-on:cancel="cancel"
			:productTag="productTag"
			:dialogProductTag="dialogProductTag"
		>
		</add-product-tag>
		<div class="vue-padding">
			<el-table
				v-loading="loading"
				:empty-text="$t('common.noData')"
				:element-loading-text="$t('common.loading')"
				:data="productTagList"
				style="width: 100%"
				max-height="638"
				:border="true"
			>
				<el-table-column
					prop="name"
					:show-overflow-tooltip="true"
					:label="$t('productTag.name')"
					:align="'center'"
				></el-table-column>
				<el-table-column
					prop="notes"
					:label="$t('productTag.notes')"
				></el-table-column>
				<el-table-column
					prop="createTime"
					:formatter="(row) => $formatDate(row.createTime)"
					:label="$t('productTag.createTime')"
					width="160"
					:align="'center'"
				></el-table-column>
				<el-table-column
					fixed="right"
					:label="$t('common.operate')"
					:width="$i18n.locale == 'zh_CN' ? 220 : 240"
					:align="'center'"
				>
					<template slot-scope="scope">
						<el-button
							size="mini"
							v-hasPerm="['product:tag:update']"
							@click="editProductTag(scope.row)"
							>{{ $t("common.edit") }}</el-button
						>
						<el-button
							size="mini"
							v-hasPerm="['product:tag:delete']"
							type="danger"
							@click="delProductTag(scope.row)"
							>{{ $t("common.delete") }}</el-button
						>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination
				v-if="productTagList.length > 0"
				background
				layout="total,sizes,prev, pager, next,jumper"
				:current-page="page.pageIndex"
				:total="page.totalSize"
				:page-size="page.pageSize"
				@size-change="sizeChange"
				@current-change="currentChange"
			></el-pagination>
		</div>
	</div>
</template>

<script>
import searchProductTag from "_c/product/SearchProductTag";
import addProductTag from "_c/product/AddProductTag";
export default {
	name: "ProductTag",
	components: {
		searchProductTag,
		addProductTag,
	},
	data() {
		return {
			search: {
				name: "",
			},
			page: {
				pageSize: 10,
				pageIndex: 1,
			},
			productTagList: [],
			loading: false,
			dialogProductTag: false,
			productTag: {
				id: "",
				name: "",
				notes: "",
			},
		};
	},
	mounted() {
		this.currentChange();
	},
	methods: {
		onSubmit(data) {
			this.search = data;
			this.currentChange();
		},
		resetSearch(data) {
			this.search = data;
			this.currentChange();
		},
		sizeChange(pageSize) {
			this.page.pageSize = pageSize;
			this.currentChange();
		},
		currentChange(pageIndex) {
			this.loading = true;
			this.page.pageIndex = pageIndex ? pageIndex : 1;
			let obj = this.$cloud.objMerge(this.search, this.page);
			this.$api
				.request(this.$url.ProductTag.page, this.$method.get, obj)
				.then(res => {
					if (res.code === 0) {
						this.productTagList = res.data.records;
						this.page.totalSize = parseInt(res.data.total);
					}
					this.loading = false;
				})
				.catch(() => {
					this.loading = false;
				});
		},
		editProductTag(row) {
			this.dialogProductTag = true;
			Object.keys(this.productTag).forEach(key => {
				this.productTag[key] = row[key];
			});
			this.productTag.id = row.id;
		},
		delProductTag(row) {
			this.$confirm(this.$t("productTag.delete"), this.$t("common.warning"), {
				confirmButtonText: this.$t("common.definite"),
				cancelButtonText: this.$t("common.cancel"),
				type: "warning",
			})
				.then(() => {
					this.$api
						.request(this.$url.ProductTag.delete, this.$method.delete, {
							id: row.id,
						})
						.then(res => {
							if (res.code === 0) {
								this.$notify({
									title: this.$t("common.tip"),
									message: res.msg,
									type: "success",
								});
								this.currentChange(this.page.pageIndex);
							}
						});
				})
				.catch(() => {});
		},
		addProductTag() {
			this.dialogProductTag = true;
		},
		cancel(dialog, state) {
			this.dialogProductTag = dialog;
			if (state) {
				this.currentChange(this.page.pageIndex);
			}
		},
	},
};
</script>

<style>
.el-dialog__header {
	padding: 20px;
}
.el-dialog__body {
	padding: 0 20px;
	height: auto !important;
}
.el-dialog__footer {
	padding: 20px;
}
</style>
